import { checkExtension, ExtensionMetadata, ExtensionType, Loader, LoaderParser, LoaderParserPriority, ResolvedAsset } from "pixi.js";
import { PromiseCompletionSource } from "scene-manager";
import { Mesh, Object3D } from "three";
import { QuarksLoader } from "three.quarks";

export class QuarksParticlesLoader implements LoaderParser<Object3D> {
    public readonly name: string;
    public readonly extension: ExtensionMetadata;
    private readonly loader: QuarksLoader;

    public constructor() {
        this.name = "quarks_particles_loader";
        this.extension = {
            type: ExtensionType.LoadParser,
            priority: LoaderParserPriority.High
        };
        this.loader = new QuarksLoader();
    }

    public test(url: string): boolean {
        return checkExtension(url, ".thjson") && url.indexOf("particles") !== -1;
    }

    public async load<T>(url: string, _resolvedAsset?: ResolvedAsset<Record<string, any>>, _loader?: Loader): Promise<T> {
        const pcs = new PromiseCompletionSource<Object3D>();
        this.loader.load(
            url,
            (result: Object3D) => pcs.complete(result),
            null,
            (reason: unknown) => pcs.error(reason)
        );
        const result = await pcs.result as T;
        return result;
    }

    public unload(asset: Object3D, resolvedAsset?: ResolvedAsset<any>, loader?: Loader) {
        if(!(asset instanceof Mesh)) {
            return;
        }

        asset.geometry.dispose();
        if(Array.isArray(asset.material)) {
            for(const material of asset.material) {
                material.dispose();
            }
        } else {
            asset.material.dispose();
            
        }
        for(const texture of asset.material.textures) {
            texture.dispose();
        }
    }
}